<app-dialog [title]="data.title" (close)="close({ close: false, save: false })">
    <ng-container dialogContent>
        <p [innerHTML]="data.message"></p>
    </ng-container>
    <ng-container dialogActions>
        <fui-button
            (clickEvent)="close({ close: true, save: true })"
            [label]="dictionary?.system_save_and_close"
            height="mini"
        >
        </fui-button>
        <fui-button
            (clickEvent)="close({ close: true, save: false })"
            [label]="dictionary?.system_close"
            height="mini"
            color="light"
        >
        </fui-button>
        <fui-button
            (clickEvent)="close({ close: false, save: false })"
            [label]="dictionary?.system_cancel"
            height="mini"
            color="light"
        >
        </fui-button>
    </ng-container>
</app-dialog>
